module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/notebook-78d202eb2bd54b480975e75f8c1e0323.png";